import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as animalGroupActions from './animal-group.actions';
import { AnimalGroup, AnimalGroupModuleState } from '../models/animal-group.model';

function selectIdNumber(c: AnimalGroup): number {
  return c.id;
}

function sortByAnimalGroupId(a: AnimalGroup, b: AnimalGroup): number {
  return b.id - a.id;
}

export const adapter: EntityAdapter<AnimalGroup> = createEntityAdapter<AnimalGroup>({
  selectId: selectIdNumber,
  sortComparer: sortByAnimalGroupId,
});

export const initialState = <AnimalGroupModuleState>{
  animalGroups: adapter.getInitialState([]),
  selectedAnimalGroupId: null,
  selectedFeedadviceApplicationId: null,
  isLoaded: false,
};

const animalGroupReducer = createReducer(
  initialState,
  on(animalGroupActions.clearAnimalGroupState, (state) => ({
    ...state,
    isLoaded: false,
    animalGroups: adapter.removeAll(state.animalGroups),
  })),
  on(animalGroupActions.loadAnimalGroupsSuccess, (state, { animalGroups }) => ({
    ...state,
    selectedAnimalGroupId: 0,
    isLoaded: true,
    animalGroups: adapter.setAll(animalGroups, state.animalGroups),
  })),
  on(animalGroupActions.upsertAnimalGroupSuccess, (state, { animalGroup }) => ({
    ...state,
    animalGroups: adapter.upsertOne(animalGroup, state.animalGroups),
    selectedAnimalGroupId: animalGroup.id,
  })),
  on(animalGroupActions.deleteAnimalGroupSuccess, (state, { animalGroup }) => ({
    ...state,
    selectedAnimalGroupId: 0,
    animalGroups: adapter.removeOne(animalGroup.id, state.animalGroups),
  })),
  on(animalGroupActions.upsertAnimalGroupGeneral, (state, { animalGroup }) => ({
    ...state,
    animalGroups: adapter.upsertOne(animalGroup, state.animalGroups),
  })),

  /** FEEDADVICE APPLICATIONS */
  on(
    animalGroupActions.addFeedadviceApplication,
    (state, { animalGroupId, feedAdviceApplication }) => ({
      ...state,
      animalGroups: adapter.updateOne(
        {
          id: animalGroupId,
          changes: {
            feedAdviceApplications: [
              ...(state.animalGroups.entities[animalGroupId].feedAdviceApplications || []),
              feedAdviceApplication,
            ],
          },
        },
        state.animalGroups,
      ),
    }),
  ),
  on(
    animalGroupActions.editFeedadviceApplication,
    (state, { animalGroupId, feedAdviceApplication }) => ({
      ...state,
      animalGroups: adapter.updateOne(
        {
          id: animalGroupId,
          changes: {
            feedAdviceApplications: [
              ...state.animalGroups.entities[animalGroupId].feedAdviceApplications.filter(
                (c) => c.id !== feedAdviceApplication.id,
              ),
              feedAdviceApplication,
            ],
          },
        },
        state.animalGroups,
      ),
    }),
  ),
  on(animalGroupActions.deleteFeedadviceApplication, (state, { animalGroupId, id }) => ({
    ...state,
    animalGroups: adapter.updateOne(
      {
        id: animalGroupId,
        changes: {
          feedAdviceApplications: [
            ...state.animalGroups.entities[animalGroupId].feedAdviceApplications.filter(
              (c) => c.id !== id,
            ),
          ],
        },
      },
      state.animalGroups,
    ),
  })),
  on(animalGroupActions.setSelectedFeedadviceApplicationId, (state, { id }) => ({
    ...state,
    selectedFeedadviceApplicationId: id,
  })),
);

export function reducer(state: AnimalGroupModuleState | undefined, action: Action) {
  return animalGroupReducer(state, action);
}
